module.exports = __webpack_public_path__ + "img/4.6-faq.7a3a34d2.png";